import { createAction, handleActions } from 'redux-actions';

const setSupplierItem = createAction("MODALS/SUPPLIER_ITEM/SET_SUPPLIER_ITEM");

const defaultState = null;

const reducer = handleActions(
  {
    [setSupplierItem]: (state, action) => action.payload
  },
  defaultState
);

export { setSupplierItem, reducer };
